module.exports = __webpack_public_path__ + "static/media/jobfinder-logo-footer.3703fb8c.png";